import React, { useState, useEffect } from 'react'
import { Logo, RightArrow } from './icons'
import { Link } from "../../plugins/gatsby-plugin-atollon"
import Clock from './clock'

const Header = (props) => {

  const [subscribe, setSubscribe] = useState(false);
  const [scrolled, setScrolled] = React.useState(false)

  let isScrolling
  let prevScroll = 0

  const onScroll = (e) => {

    let scr, hhScrolled

    const curScroll = window.scrollY || document.scrollTop
    scr = curScroll > 1

    // Make sure they scroll more than 5px
    if (Math.abs(prevScroll - curScroll) <= 5) return

    prevScroll = curScroll

    requestAnimationFrame(() => {
      setScrolled(scr)
    })
  }

  const scrollDetect = () => {
    window.clearTimeout(isScrolling)
    isScrolling = setTimeout(onScroll, 0)
  }

  useEffect(() => {
    window.addEventListener("scroll", scrollDetect, false)
    return () => {
      window.removeEventListener("scroll", scrollDetect, false)
    }
  }, [])

  let headerClass = scrolled ? 'header header--scrolled' : 'header'
  headerClass = props.subscribe
    ? headerClass + ' header--subscribe'
    : headerClass

  return (
    <>
      <header className={headerClass}>
        <div className='header__inner'>
          <Clock />
          <div className='header__logo'>
            <Link to='/'>
              <Logo />
            </Link>
          </div>
          <div className='header__subscribe'>
            { !props.subscribe ?
            <>
              <button className='btn btn--desktop' onClick={() => props.setSubscribe(true)}>
                <span>Stay up to date</span>
                <RightArrow />
              </button>
              <button className='btn btn--mobile' onClick={() => props.setSubscribe(true)}>
                <span>Subscribe</span>
              </button>
            </>
            : 
              <button className='btn' onClick={() => props.setSubscribe(false)}>
                <span>Back</span>
                <RightArrow />
              </button>
            }
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
